module.exports = __webpack_public_path__ + "static/sec3-bg-sm-7ab13019475e7dbe8d4adc156336eb85.jpg";